package com.islamicmedia.shared.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Per-user pin / hide state for one title in the "Your Analyses" list. Synced via
 * /api/media-prefs so a pin made on the phone also floats the title on the web.
 *
 * [titleKey] is normalised server-side (lowercase title with any trailing "(YYYY)" stripped,
 * plus "::MEDIA_TYPE") — build it client-side with [mediaPrefKey] so lookups line up.
 */
@Serializable
data class MediaPref(
    @SerialName("title_key") val titleKey: String,
    /** ISO-8601 pin time; null = not pinned. Newest pin sorts to the very top. */
    @SerialName("pinned_at") val pinnedAt: String? = null,
    /** Dropped from the list, but NOT deleted — re-analyzing the title brings it back. */
    val hidden: Boolean = false
)

@Serializable
data class MediaPrefsResult(val prefs: List<MediaPref> = emptyList())

/** Client-side twin of the server's key normalisation. Keep the two in step. */
fun mediaPrefKey(title: String, mediaType: MediaType): String {
    val base = title.replace(Regex("""\s*\(\d{4}\)\s*$"""), "").trim().lowercase()
    return "$base::${mediaType.name}"
}
